import { SovosButton, SovosDivider, SovosLink } from 'mosaic-react';
import { useNavigate } from 'react-router-dom';

import styles from './EmptyPage.module.scss';

const EmptyPage: React.FC<{
	image?: JSX.Element | null;
	subtitle: string;
	title: string;
	titleButton: string;
}> = ({ image, subtitle, title, titleButton }) => {
	const navigate = useNavigate();
	const SSO_ZENDESK = sessionStorage.getItem('sso');

	return (
		<>
			<SovosDivider />
			<div id='emptyPage' className={styles['empty-page']}>
				<div className={styles.container}>
					{image ?? (
						<img
							alt='EmptyPageIllustration'
							draggable='false'
							height='auto'
							src='./images/EmptyPageIllustration.png'
						/>
					)}
					<h4 className={styles.title}>{title}</h4>
					<h6 className={styles.subtitle}>
						{subtitle}
						<br />
						{`Go to the`}
						<SovosLink
							href={
								SSO_ZENDESK
									? `https://salestax.help.sovos.com/${SSO_ZENDESK}`
									: 'https:/salestax.help.sovos.com'
							}
							target='_blank'
							rel='noopener noreferrer'
							className={styles.link}
						>
							{` Sovos Help Center `}
						</SovosLink>
						{`for step-by-step instructions.`}
					</h6>
					<div className={styles.button}>
						<SovosButton onClick={() => navigate('./new')}>
							{titleButton}
						</SovosButton>
					</div>
				</div>
			</div>
		</>
	);
};

export default EmptyPage;
